// Vista subcategoprías
import React from 'react';
import API from '../../configAPI';
import PulseLoader from 'react-spinners/PulseLoader';
import {Link} from 'react-router-dom';
import CONFIG from '../../config';
import BannerLarge from '../partials/BannerLarge';
import { data } from 'jquery';
import Pagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import ProductItem from '../product/ProductItem';
import BimFilter from '../bim/BimFilter';


class SubcatesCategoryBim extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            categ_slug : this.props.match.params.category,
            category : {
                item : {}
            },
            sub_categories: [],

            loading : true,
            title_app: 'Productos',
            is_filtered: false,

            products : {
                data: [],
                current_page: 1,
                total: 0,
                last_page: 1
            },
        }
    }
    componentDidMount(){
        API.PRODUCTS(`bim/sub-categories/category/${this.state.categ_slug}`)
        .then(resp =>{
            this.setState({
                category : resp.data.category,
                products:resp.data.products,
                sub_categories:resp.data.sub_categories,
                loading : false
            });
            console.log(resp.data);
        })
        .catch(err =>{
            console.log(err);
        });
    }

    render(){
        return(
            <div className="container-fluid mt-3 mb-3">
                
                <div className="col-12">
                    <PulseLoader
                        css={CONFIG.spinner_css}
                        size={CONFIG.spinner_size}
                        margin={CONFIG.spinner_margin}
                        color={CONFIG.spinner_color}
                        loading={this.state.loading}
                    />
                    <div className="col-md-10 mx-auto">
                        <h2 className="title-bim"><span>BIM y CAD de productos reales</span></h2>
                        <br></br>
                    </div>
                    <div className="row mt-2 mb-2 d-flex flex-wrap">
                        <div className="col-xs-12 col-md-3 mt-1 mb-1">
                            
                        <BimFilter format_slug=""/>
                        
                            <div className="list-group">
                                <li className="list-group-item secondary bg-black">{this.state.category.name}</li>
                                {this.state.sub_categories.map((cat,index) =>(
                                   
                                    <Link to={this.state.category.slug+'/'+cat.slug} key={index} className="list-group-item d-flex justify-content-between align-items-center list-group-item-action item-menu">
                                        {cat.name} <span className="badge badge-secondary">{/*cat.products_count*/}</span>
                                    </Link>
                                    
                                ))}
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-9 mt-1 mb-1">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb row">
                                <li className="breadcrumb-item active" aria-current="page">
                                            <Link to='/bim'>BIM</Link>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            <Link to={'/bim/'+this.state.category.item.slug}>{this.state.category.item.name}</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                        {this.state.category.name}&nbsp;&nbsp;-&nbsp;&nbsp;
                                        <span className="badge badge-secondary"> {this.state.products.total}</span> {this.state.title_app}
                                        {this.state.is_filtered ? 
                                        <button onClick={this.getProducts} className="btn btn-outline-success btn-sm float-right">Quitar filtros 
                                        <i className="fas fa-filter"></i></button>
                                        : ''
                                        }
                                        </li>  
                                </ol>
                            </nav>
                            <div className="mt-3 d-flex justify-content-center">
                                {this.state.products.last_page > 1 &&
                                    <Pagination 
                                        onChange={this.onChanhePage}
                                        current={this.state.products.current_page}
                                        total={this.state.products.total}
                                        showTitle={false}
                                        defaultPageSize={this.state.products.to}
                                    />
                                }
                            </div>
                            <div className="row d-flex flex-wrap mt-1">
                                
                            {this.state.products.total > 0 ? <ProductItem products={this.state.products.data}/> : 'Sin resultados'}
                                
                            </div>
                            <div className="mt-3 d-flex justify-content-center">
                                {this.state.products.last_page > 1 &&
                                    <Pagination 
                                        onChange={this.onChanhePage}
                                        current={this.state.products.current_page}
                                        total={this.state.products.total}
                                        showTitle={false}
                                        defaultPageSize={this.state.products.to}
                                    />
                                }
                            </div>
                        </div>
                    </div>

                   {/* <div className="page-header">Todas las categorías</div>
                    <div className="row d-flex flex-wrap  justify-content-beetwen">

                        {this.state.items.map((item,index) =>(
                            <article className="col-6 col-sm-6 col-md-3 mt-2" key={index}>
                                <div className="rubro">
                                    <Link to={`/productos/${item.slug}`}>
                                            <img src={item.url_image} alt={item.name}/>
                                            <h3>{item.name}</h3>
                                    </Link>
                                    <ul>
                                        {item.categories.map((categ,index2)=>(
                                            (index2 < 5 ?
                                                <li key={index2}><Link to={`/productos/${item.slug}/${categ.slug}`}>{categ.name}</Link></li>
                                                : ''
                                            )
                                        ))}
                                        <li><Link to={`/productos/${item.slug}`} className="link">Ver más</Link></li>
                                    </ul>
                                </div>
                            </article>
                        ))}
                    </div>*/}
                </div>

                <BannerLarge 
                    url="https://dossierdearquitectura.com/"
                    image="https://dossierdearquitectura.com/banner/da728x160.jpg"
                    title="Visite Dossier de Arquitectura"
                />
            </div>
        )
    }
}
export default SubcatesCategoryBim;